let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("81ecZ")).then(() => parcelRequire('cFqmA'));